import { render, staticRenderFns } from "./GroupingElement.vue?vue&type=template&id=3988bc48&"
import script from "./GroupingElement.vue?vue&type=script&lang=ts&"
export * from "./GroupingElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports